module.exports = __webpack_public_path__ + "images/2b14960f5709f464e7e3892029f25e1a.jpg";